import { createSlice } from "@reduxjs/toolkit";

const initialWorkersState = {
  listLoading: false,
  listLoader: false,
  actionsLoading: false,
  totalCount: 0,
  entities: [],
  locationForEdit: {
    id: undefined,
    loc_name: "",
    loc_type: "",
    loc_street1: "",
    loc_street2: "",
    countryName: "",
    stateName: "",
    cityName: "",
    loc_phone: "",
    pincode: "",
    lat: "",
    long: "",
    location_notes: "",
    location_contact: "",
  },
  message: null,
  messageType: null,
  showMessage: false,
};

export const callTypes = {
  list: "list",
  action: "action",
};

export const locationSlice = createSlice({
  name: "location",
  initialState: initialWorkersState,
  reducers: {
    catchError: (state, action) => {
      state.error = `${action.type}: ${action.payload.error}`;
      if (action.payload.callType === callTypes.list) {
        state.listLoading = false;
      } else {
        state.actionsLoading = false;
      }
    },
    startCall: (state, action) => {
      state.error = null;
      if (action.payload.callType === callTypes.list) {
        state.listLoading = true;
      } else {
        state.actionsLoading = true;
      }
    },
    // location loader
    locationListLoading: (state, action) => {
      state.listLoading = action.payload;
    },
    locationList: (state, action) => {
      const { result, count } = action.payload;

      state.totalCount = count;
      state.entities = result;
      state.listLoader = false;
    },
    listLoad: (state, action) => {
      state.listLoader = action.payload;
    },
    loadLocationForEdit: (state, action) => {
      let temp = {
        id: action.payload.id,
        loc_name: action.payload.name,
        loc_type: action.payload.type,
        loc_street1: action.payload.street1,
        loc_street2: action.payload.street2,
        countryName: action.payload.countryName,
        stateName: action.payload.stateName,
        cityName: action.payload.cityName,
        loc_phone: action.payload.phoneNo,
        pincode: action.payload.pincode,
        lat: action.payload.lat,
        long: action.payload.long,
        location_notes: action.payload.locationNotes,
        location_contact: action.payload.locationContact,
      };

      state.locationForEdit = temp;
    },
    loadLocationMessage: (state, action) => {
      const { message, type } = action.payload;

      state.message = message;
      state.messageType = type;
      state.showMessage = true;
    },
  },
});
